export default "__VITE_ASSET__8b27e02e__"